export enum CATEGORIES_KEY {
  CATEGORY_NEWS = "news",
  CATEGORY_SCIENCE = "science",
  CATEGORY_HEALTH = "health",
  CATEGORY_AED = "aed",
  CATEGORY_FACILITY = "facilities",
  CATEGORY_HEATER = "heater",
}

export const CATEGORIES = {
  [CATEGORIES_KEY.CATEGORY_NEWS]: "お知らせ",
  [CATEGORIES_KEY.CATEGORY_SCIENCE]: "理科機器",
  [CATEGORIES_KEY.CATEGORY_HEALTH]: "保健福祉",
  [CATEGORIES_KEY.CATEGORY_AED]: "救急救命",
  [CATEGORIES_KEY.CATEGORY_FACILITY]: "教育施設",
  [CATEGORIES_KEY.CATEGORY_HEATER]: "工業用ヒーター",
};
